var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 2.55509C23.117 2.94709 22.168 3.21109 21.172 3.33009C22.189 2.72109 22.97 1.75609 23.337 0.606094C22.386 1.17009 21.332 1.58009 20.21 1.80109C19.313 0.844094 18.032 0.246094 16.616 0.246094C13.437 0.246094 11.101 3.21209 11.819 6.29109C7.728 6.08609 4.1 4.12609 1.671 1.14709C0.381 3.36009 1.002 6.25509 3.194 7.72109C2.388 7.69509 1.628 7.47409 0.965 7.10509C0.911 9.38609 2.546 11.5201 4.914 11.9951C4.221 12.1831 3.462 12.2271 2.69 12.0791C3.316 14.0351 5.134 15.4581 7.29 15.4981C5.22 17.1211 2.612 17.8461 0 17.5381C2.179 18.9351 4.768 19.7501 7.548 19.7501C16.69 19.7501 21.855 12.0291 21.543 5.10409C22.505 4.40909 23.34 3.54209 24 2.55509Z","fill":"#151515"}));
}

TwitterInline.defaultProps = {"width":"24","height":"20","viewBox":"0 0 24 20","fill":"none"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
